import styled from 'styled-components'

import { Skeleton } from '@root/shared/ui-kit'

export const ProfileBoardStatisticsSkeleton: React.FC = () => (
  <Root>
    <HeaderLeft>
      <Skeleton width={108} height={28} />
      <Skeleton width={72} height={28} />
    </HeaderLeft>
    <WalletSelector>
      <Skeleton width={22} height={22} variant="circular" />
      <Skeleton width={88} height={14} />
    </WalletSelector>
  </Root>
)

const Root = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 15px;
`

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const WalletSelector = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`
